import React from "react";
type VerbChipsProps = {
  text: string;
  tone?: "light" | "dark";
  className?: string;
};

// Convierte "RECONOCÉ. NOMBRÁ. DIFERENCIÁ." en chips dorados.
export function VerbChips({
  text,
  tone = "light",
  className = ""
}: VerbChipsProps) {
  const verbs = text.split(".").map(v => v.trim()).filter(Boolean);
  const styles = tone === "light" ? "bg-gold/15 text-gold-ink ring-gold/35" : "bg-gold/15 text-gold ring-gold/40";
  return <ul className={`flex flex-wrap gap-1.5 ${className}`} aria-label={text} data-id="element-208" data-mp="1cbn034xy4dri">
      {verbs.map(verb => <li key={verb} className={`rounded-full px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide ring-1 ${styles}`} data-id="element-209" data-mp="179fkm5dwqfkf">
          {verb}.
        </li>)}
    </ul>;
}